import { AnalyzeSyntheticConfigsToHandle } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const SocieteConfigAnalyseSyntheseActions = createActionGroup({
  source: 'Societe Config Analyse Synthese',
  events: {
    'Handle Many Societe Config Analyse Synthese': props<{ configs: AnalyzeSyntheticConfigsToHandle }>()
  }
});
